import { render, staticRenderFns } from "./BagsList.vue?vue&type=template&id=5daea7ca&"
import script from "./BagsList.vue?vue&type=script&lang=js&"
export * from "./BagsList.vue?vue&type=script&lang=js&"
import style0 from "./BagsList.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BagsList.vue"
export default component.exports